<div class="prefs-toggle">
  <button mat-icon-button (click)="toggle()" matTooltip="Preferencias">
    <mat-icon>settings</mat-icon>
  </button>
</div>

<div *ngIf="open" class="prefs-overlay">
  <div class="prefs-panel">
    <div class="prefs-header">
      <h3>Preferencias</h3>
      <button mat-icon-button (click)="toggle()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="prefs-body">
      <div class="prefs-field">
        <label>Nivel de detalle</label>
        <select [(ngModel)]="prefs.nivel_detalle">
          <option *ngFor="let dl of detailLevels" [value]="dl.value">{{ dl.label }}</option>
        </select>
      </div>
      <div class="prefs-field">
        <label>Contexto del rol</label>
        <input type="text" [(ngModel)]="prefs.contexto_rol" placeholder="Ej: comercial" />
      </div>
    </div>
    <div class="prefs-footer">
      <button mat-flat-button color="primary" (click)="save()">Guardar</button>
    </div>
  </div>
</div>
